import { ParameterizedRemoteData, RemoteData } from "../Infra/RemoteData";
export class CollectivePatientStatsManager {
    constructor(statsService, authManager, invalidationManager) {
        this.statsService = statsService;
        this.authManager = authManager;
        this.invalidationManager = invalidationManager;
        this.current = new RemoteData(this.invalidationManager, () => this.statsService.getStatsCurrent());
        this.timeline = new RemoteData(this.invalidationManager, () => this.statsService.getStatsTimeline());
        this.breakdown = new RemoteData(this.invalidationManager, () => this.statsService.getStatsBreakdown());
        this.currentForOrganization = new ParameterizedRemoteData(this.invalidationManager, () => this.authManager.orgId, (orgId) => (orgId ? this.statsService.getStatsCurrentForOrganization(orgId) : null));
        this.timelineForOrganization = new ParameterizedRemoteData(this.invalidationManager, () => this.authManager.orgId, (orgId) => (orgId ? this.statsService.getStatsTimelineForOrganization(orgId) : []));
        this.breakdownForOrganization = new ParameterizedRemoteData(this.invalidationManager, () => this.authManager.orgId, (orgId) => (orgId ? this.statsService.getStatsBreakdownForOrganization(orgId) : null));
        this.currentForPatient = new ParameterizedRemoteData(this.invalidationManager, () => [this.authManager.orgId, this.authManager.id, this.authManager.userType], () => this.getPatientStats());
    }
    async getPatientStats() {
        const organizationId = this.authManager.orgId;
        const patientId = this.authManager.id;
        if (organizationId && patientId && this.authManager.userType === "PATIENT") {
            return await this.statsService.getStatsCurrentForPatient(organizationId, patientId);
        }
        else {
            return null;
        }
    }
}
